import {
  FileUploadState,
  FILE_UPLOAD_SESSION_STATE_TYPE,
} from '../../../store';

export const shouldDisableSubmissionForFileUpload = (
  fileUpload: FileUploadState,
): boolean => {
  if (fileUpload.setting == null) {
    return false;
  }
  if (fileUpload.session.type !== FILE_UPLOAD_SESSION_STATE_TYPE.ready) {
    return true;
  }
  return Object.values(fileUpload.items).some(
    (item) => item.awaiting || item.needsToReload,
  );
};
